module.exports = __webpack_public_path__ + "static/media/new_marker.2f415594.svg";